// require('./bootstrap');
import Alpine from 'alpinejs'
import Tooltip from "@ryangjchandler/alpine-tooltip"

Alpine.plugin(Tooltip);

// dev only
// window.Alpine = Alpine

Alpine.start();

window.scrollLockRoot = () => document.querySelector('html').style.overflow = 'hidden';
window.scrollUnLockRoot = () => document.querySelector('html').style.overflow = 'visible';
